module.exports = __webpack_public_path__ + "static/media/icon6.b7af6997.svg";